import { z } from 'zod';
import { BaseResponseSchema, containerSlotSchema, containerTypeSchema, dateSchema, integerIdSchema, uuidSchema, waferFingerprintSchema, } from './primitives.js';
// ================================
// Temp Fingerprint Schemas
// ================================
export const UpdateExtractionRequestSchema = z.object({
    fingerprint: waferFingerprintSchema,
    method: z.string().min(1).max(50),
    confidence: z.number().min(0).max(100).optional()
});
export const LinkWaferRequestSchema = z.object({
    fingerprint: waferFingerprintSchema,
    confidence: z.number().min(0).max(100).optional()
});
export const UpdateProcessingRequestSchema = z.object({
    status: z.enum(['processing', 'completed', 'failed']),
    error: z.string().min(1).max(500).optional()
});
export const BulkUpdateRequestSchema = z.object({
    fingerprintIds: z.array(waferFingerprintSchema),
    status: z.enum(['processing', 'completed', 'failed']),
    error: z.string().min(1).max(500).optional()
});
export const PendingFingerprintsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).optional()
});
export const TempFingerprintResponseSchema = z.object({
    id: uuidSchema,
    collectionSessionId: uuidSchema,
    efemClientId: integerIdSchema,
    loadPortId: z.number().int().positive(),
    slotNumber: containerSlotSchema,
    containerId: integerIdSchema.optional(),
    containerType: containerTypeSchema.optional(),
    rawFingerprint: z.string().optional(),
    extractedFingerprint: z.string().optional(),
    matchedFingerprint: z.string().optional(),
    extractionMethod: z.string().optional(),
    extractionConfidence: z.number().optional(),
    matchConfidence: z.number().optional(),
    processingStatus: z.enum(['processing', 'completed', 'failed']),
    imageFormat: z.string().optional(),
    imageSize: z.number().optional(),
    createdAt: dateSchema,
    updatedAt: dateSchema,
    processed: z.boolean().optional(),
    processedAt: dateSchema.optional(),
    summary: z.any().optional(),
    collection: z.any().optional()
});
export const GetPendingFingerprintsResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        fingerprints: z.array(TempFingerprintResponseSchema),
        total: z.number().int()
    })
});
export const GetSessionFingerprintsResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        sessionId: uuidSchema,
        fingerprints: z.array(TempFingerprintResponseSchema),
        total: z.number().int()
    })
});
export const UpdateFingerprintResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        id: uuidSchema,
        extractedFingerprint: z.string().optional(),
        extractionMethod: z.string().optional(),
        extractionConfidence: z.number().optional(),
        matchedFingerprint: z.string().optional(),
        matchConfidence: z.number().optional(),
        processingStatus: z.enum(['processing', 'completed', 'failed']),
        processed: z.boolean().optional(),
        processedAt: dateSchema.optional(),
        processingError: z.string().optional(),
        summary: z.any().optional()
    })
});
export const FingerprintStatsResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        total: z.number().int(),
        pending: z.number().int(),
        processing: z.number().int(),
        completed: z.number().int(),
        failed: z.number().int(),
        byCollectionSession: z.record(z.number().int())
    })
});
export const CleanupResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        cleanedCount: z.number().int()
    })
});
//# sourceMappingURL=temp-fingerprint-queue.schemas.js.map